import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { CreateAuditModal } from './EditAudit/components/CreateAuditModal'
import { AppView, AppMainView } from '../../../../components/AppView'
import { Routes } from '../../../../constants/Routes'
import AppHeader from '../../../../components/AppView/Header'
import { CurrentUserStore } from '../../../../stores/CurrentUserStore'
import AppPagination from '../../../../components/Pagination/index'
import { NoPermissionsResult } from '../../../../components/NoPermissionsResult'
import { HelpLinkMenu } from '../../../../components/GrDropdown/HelpLinkMenu/HelpLinkMenu'
import { BlazeButton } from '../../../../components/CustomButtons/BlazeButton'
import Helmet from 'react-helmet'
import { AuditFilterStore } from './Main/AuditFilterStore'
import { AuditTableFilter } from './Main/AuditTableFilter'
import { AuditTableList } from './Main/AuditTableList'
import { PermissionNames } from '@getgreenline/homi-shared'
import { HelpLinks } from '../../../../constants/ExternalLinks'
import { Typography } from 'antd-v4'

interface Props {
  currentCompanyStore: CurrentCompanyStore
  currentUserStore: CurrentUserStore
  router: any
}

interface State {
  showCreateModal: boolean
  errorMessage?: string
}
@inject('currentCompanyStore', 'currentUserStore')
@observer
export class Audit extends React.Component<Props, State> {
  company = this.props.currentCompanyStore!.company!
  auditFilterStore = new AuditFilterStore(this.company.id)
  constructor(props: Props) {
    super(props)
    this.state = {
      showCreateModal: false,
    }
  }

  componentDidMount = async () => {
    const locations = await this.props.currentCompanyStore!.getLocations()
    this.auditFilterStore.setLocations(locations)

    await this.auditFilterStore.loadAudits()
  }

  render() {
    const canViewAudits = this.props.currentUserStore.hasPermissionAtEntity(
      PermissionNames.CAN_VIEW_AUDITS,
      this.company.id,
    )
    const canEditAudits = this.props.currentUserStore.hasPermissionAtEntity(
      PermissionNames.CAN_EDIT_AUDITS,
      this.company.id,
    )

    if (!canViewAudits) {
      return <NoPermissionsResult permissionName={PermissionNames.CAN_VIEW_AUDITS} />
    }

    return (
      <AppView column>
        <Helmet>
          <title>Inventory | Audits</title>
          <meta name='page-loaded' content='true' />
        </Helmet>
        <AppHeader title='Audits'>
          <span className='spaced-button-wrapper'>
            <HelpLinkMenu
              helpLinkMenus={{
                href: HelpLinks.AUDITS,
                title: 'Counting inventory',
              }}
            />

            <BlazeButton
              buttonProps={{
                id: 'add-product-button',
                type: 'primary',
                icon: 'plus',
                onClick: () => this.setState({ showCreateModal: true }),
                disabled: !canEditAudits,
              }}
              titleProps={{
                title: 'Add audit',
              }}
            />
          </span>
        </AppHeader>

        <AppMainView className='background-grey intercom-pb-2'>
          <>
            <AuditTableFilter auditFilterStore={this.auditFilterStore} />

            <AuditTableList auditFilterStore={this.auditFilterStore} />

            <AppPagination
              currentPage={this.auditFilterStore.currentPage}
              pageCount={this.auditFilterStore.pageCount}
              onPageChange={({ selected }: { selected: number }) => {
                this.auditFilterStore.loadAudits(selected * this.auditFilterStore.paginationLimit)
              }}
            />
          </>
        </AppMainView>

        {this.state.showCreateModal && (
          <CreateAuditModal
            onSubmit={(inventoryAudit) => {
              this.props.router.push(
                Routes.EDIT_INVENTORY_AUDIT(
                  this.props.currentCompanyStore!.company!.id,
                  inventoryAudit.id,
                ),
              )
            }}
            onClose={() => this.setState({ showCreateModal: false })}
          />
        )}
      </AppView>
    )
  }
}
